import { Collapse, LinearProgress } from '@material-ui/core';
import styled from 'styled-components';

const LoadingContainer = styled.div`
  position: relative;
`;

const LinearProgressCollapse = styled(Collapse)`
  top: 0;
  left: 0;
  right: 0;
  position: absolute;
  z-index: ${({ theme }) => theme.zIndex.appBar + 10};
`;

export function PostingsLoadingState({ loading }: { loading?: boolean }) {
  return (
    <LoadingContainer>
      <LinearProgressCollapse in={loading}>
        <LinearProgress />
      </LinearProgressCollapse>
    </LoadingContainer>
  );
}
